import { ChainId, WRAPPED_SOL, ZERO_ADDRESS } from '@shared/utils/config/networks';
export const EthAddresses = {
  Eth: {
    address: ZERO_ADDRESS,
    network: ChainId.ETHEREUM
  },
  Base: {
    address: ZERO_ADDRESS,
    network: ChainId.BASE
  },
  Optimism: {
    address: ZERO_ADDRESS,
    network: ChainId.OPTIMISM
  },
  Arbitrum: {
    address: ZERO_ADDRESS,
    network: ChainId.ARBITRUM
  }
};
export const wBTCAddresses = {
  Solana: {
    address: '3NZ9JMVBmGAqocybic2c7LQCJScmgsAZ6vQqTDzcqmJh',
    network: ChainId.SOLANA
  },
  Optimism: {
    address: '0x68f180fcce6836688e9084f035309e29bf0a2095',
    network: ChainId.OPTIMISM
  },
  Sui: {
    address: '0xaafb102dd0902f5055cadecd687fb5b71ca82ef0e0285d90afde828ec58ca96b::btc::BTC',
    network: ChainId.SUI
  },
  Arbitrum: {
    address: '0x2f2a2543B76A4166549F7aaB2e75Bef0aefC5B0f',
    network: ChainId.ARBITRUM
  },
  Avax: {
    address: '0x50b7545627a5162f82a992c33b87adc75187b218',
    network: ChainId.AVALANCHE
  },
  Polygon: {
    address: '0x1bfd67037b42cf73acf2047067bd4f2c47d9bfd6',
    network: ChainId.POLYGON
  },
  wBTC: {
    address: '0x2260fac5e5542a773aa44fbcfedf7c193bc2c599',
    network: ChainId.ETHEREUM
  }
};
export const ChainLinkAddresses = {
  Optimism: {
    address: '0x350a791bfc2c21f9ed5d10980dad2e2638ffa7f6',
    network: ChainId.OPTIMISM
  },
  Arbitrum: {
    address: '0xf97f4df75117a78c1A5a0DBb814Af92458539FB4',
    network: ChainId.ARBITRUM
  },
  Avax: {
    address: '0x6f3a0c89f611ef5dc9d96650324ac633d02265d3',
    network: ChainId.AVALANCHE
  },
  Polygon: {
    address: '0x53e0bca35ec356bd5dddfebbd1fc0fd03fabad39',
    network: ChainId.POLYGON
  },
  Eth: {
    address: '0x514910771af9ca656af840dff83e8264ecf986ca',
    network: ChainId.ETHEREUM
  },
  BnB: {
    address: '0xf8a0bf9cf54bb92f17374d9e9a321e6a111a51bd',
    network: ChainId.BSC
  }
};
export const TopTokenAddresses = {
  Eth: {
    address: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
    network: ChainId.ETHEREUM
  },
  Btc: {
    address: '0x2260fac5e5542a773aa44fbcfedf7c193bc2c599',
    network: ChainId.ETHEREUM
  },
  Usdc: {
    address: '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48',
    network: ChainId.ETHEREUM
  },
  Usdt: {
    address: '0xdac17f958d2ee523a2206206994597c13d831ec7',
    network: ChainId.ETHEREUM
  },
  Link: {
    address: '0xf8a0bf9cf54bb92f17374d9e9a321e6a111a51bd',
    network: ChainId.BSC
  },
  Dai: {
    address: '0xd586e7f844cea2f87f50152665bcbc2c279d8d70',
    network: ChainId.AVALANCHE
  },
  Solana: {
    address: WRAPPED_SOL,
    network: ChainId.SOLANA
  },
  // BnB: { address: '0x0efb5FD2402A0967B92551d6AF54De148504A115', network: ChainId.BSC },
  Doge: {
    address: '0xba2ae424d960c26247dd6c32edc70b295c744c43',
    network: ChainId.BSC
  }
  // Avax: { address: '0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7', network: ChainId.AVALANCHE },
};
export const StableTokenAddresses = {
  Usdc: {
    Solana: {
      address: 'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v',
      network: ChainId.SOLANA
    },
    Base: {
      address: '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913',
      network: ChainId.BASE
    },
    Avalanche: {
      address: '0xB97EF9Ef8734C71904D8002F8b6Bc66Dd9c48a6E',
      network: ChainId.AVALANCHE
    },
    Optimism: {
      address: '0x0b2C639c533813f4Aa9D7837CAf62653d097Ff85',
      network: ChainId.OPTIMISM
    },
    Arbitrum: {
      address: '0xaf88d065e77c8cC2239327C5EDb3A432268e5831',
      network: ChainId.ARBITRUM
    },
    Sui: {
      address: '0xdba34672e30cb065b1f93e3ab55318768fd6fef66c15942c9f7cb846e2f900e7::usdc::USDC',
      network: ChainId.SUI
    },
    Polygon: {
      address: '0x3c499c542cef5e3811e1192ce70d8cc03d5c3359',
      network: ChainId.POLYGON
    },
    Ethereum: {
      address: '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48',
      network: ChainId.ETHEREUM
    }
  },
  Usdt: {
    Solana: {
      address: 'Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB',
      network: ChainId.SOLANA
    },
    Bsc: {
      address: '0x55d398326f99059ff775485246999027b3197955',
      network: ChainId.BSC
    },
    Avalanche: {
      address: '0x9702230A8Ea53601f5cD2dc00fDBc13d4dF4A8c7',
      network: ChainId.AVALANCHE
    },
    Optimism: {
      address: '0x94b008aa00579c1307b0ef2c499ad98a8ce58e58',
      network: ChainId.OPTIMISM
    },
    Arbitrum: {
      address: '0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9',
      network: ChainId.ARBITRUM
    },
    Polygon: {
      address: '0xc2132d05d31c914a87c6611c10748aeb04b58e8f',
      network: ChainId.POLYGON
    },
    Ethereum: {
      address: '0xdac17f958d2ee523a2206206994597c13d831ec7',
      network: ChainId.ETHEREUM
    }
  },
  Dai: {
    Base: {
      address: '0x50c5725949A6F0c72E6C4a641F24049A917DB0Cb',
      network: ChainId.BASE
    },
    Bsc: {
      address: '0x1af3f329e8be154074d8769d1ffa4ee058b1dbc3',
      network: ChainId.BSC
    },
    Avalanche: {
      address: '0xd586E7F844cEa2F87f50152665BCbc2C279D8d70',
      network: ChainId.AVALANCHE
    },
    Optimism: {
      address: '0xda10009cbd5d07dd0cecc66161fc93d7c9000da1',
      network: ChainId.OPTIMISM
    },
    Arbitrum: {
      address: '0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1',
      network: ChainId.ARBITRUM
    },
    Polygon: {
      address: '0x8f3Cf7ad23Cd3CaDbD9735AFf958023239c6A063',
      network: ChainId.POLYGON
    },
    Ethereum: {
      address: '0x6b175474e89094c44da98b954eedeac495271d0f',
      network: ChainId.ETHEREUM
    }
  }
};